import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { DefaultButton, Stack, useTheme } from "@bps/fluent-ui";
import { SectionTitle } from "@components/SectionTitle";
import { withPermissions } from "@components/withPermissions";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { SelectorArgs } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useSelectors } from "@libs/api/gateways/field/field-ops-gateway.hooks";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";
import { Permissions } from "@libs/permissions/permissions.enum";

import { Selectors } from "./Selectors";
import { SelectorsFilter } from "./SelectorsTableFilter";

const SelectorsScreenBase: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [filtersArgs, setFilterArgs] = useState<SelectorArgs>();

  const {
    data: selectorData,
    isLoading: isSelectorDataLoading,
    error: selectorError
  } = useSelectors(filtersArgs);

  const { data: hasWritePermission } = usePermissionsCheckQuery(
    Permissions.PltFieldManagementWrite
  );

  return (
    <Stack verticalFill>
      <Stack
        verticalFill
        styles={{
          root: { padding: theme.spacing.s1, width: "100%" }
        }}
        tokens={{ childrenGap: theme.spacing.m }}
      >
        <Stack horizontal horizontalAlign="space-between">
          <SectionTitle>Selectors</SectionTitle>

          <Stack.Item align="end">
            <DefaultButton
              iconProps={{ iconName: "Add" }}
              onClick={() => navigate("new")}
              disabled={!hasWritePermission}
              title={!hasWritePermission ? NO_ACTION_PERMISSION : undefined}
            >
              Create Selector
            </DefaultButton>
          </Stack.Item>
        </Stack>
        <SelectorsFilter setFilterArgs={setFilterArgs} />
        <Selectors
          items={selectorData ?? []}
          enableShimmer={isSelectorDataLoading}
          errorMessage={selectorError?.message}
          isSelectedOnFocus
        />
      </Stack>
    </Stack>
  );
};

export const SelectorsScreen = withPermissions(
  SelectorsScreenBase,
  [Permissions.PltFieldManagementRead, Permissions.PltFieldManagementWrite],
  "or"
);
